/** Old link to one RSW report: carried over, filters and all, to Reports > Warehouse at RSW (2026-10-16). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { reportSearch } from "@/features/warehouse/reports/api";

export const Route = createFileRoute("/_app/warehouse/$stage/reports/$key")({
  validateSearch: reportSearch,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/reports/warehouse/$slug",
      params: { slug: params.key },
      search: { ...search, stage: "raw" },
      replace: true,
    });
  },
});
